module.exports = __webpack_public_path__ + "img/Methodical Organiser.3729d752.svg";